import Modal from '../../../components/Modal';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken, setImage } from '../../../redux/slices/customizeCard';
import { openModal } from '../../../redux/slices/modals';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';
import { fetchImageAsBase64 } from '../../../utils/images';
import Button from '../../../components/Button';

const CardContainer = styled.div`
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
  }
`;

const Card = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% * 226 / 407); /* Aspect ratio for Card */
  background-color: ${({ theme }) => theme.background.primary};
  border-radius: 15px;
  border: 1px solid ${({ theme }) => theme.border.primary};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  background-image: ${({ $background }) =>
    $background ? `url(${$background})` : 'none'};
  background-size: cover;
  background-position: center;
  cursor: pointer;
`;

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  overflow: auto;
  max-height: 60vh;
  margin: 40px 0;
  width: 100%;

  @media ${PHONE_MEDIA_QUERY} {
    grid-template-columns: 1fr; /* Single column on mobile */
  }
`;

const SelectCardModal = ({ onClose, token, onSelectCard }) => {
  const dispatch = useDispatch();

  const aspectRatio = 226 / 407;

  const cardWidth = 450;
  const cardHeight = cardWidth * aspectRatio;

  const cardSize = {
    width: cardWidth,
    height: cardHeight,
  };

  return (
    <Modal onClose={onClose} width='700px'>
      <h3>Select Card Theme</h3>
      <CardsContainer>
        {token?.giftCardImages?.map((image) => {
          return (
            <CardContainer>
              <Card
                $background={image?.imageUrl}
                onClick={async () => {
                  const base64Image = await fetchImageAsBase64(image?.imageUrl);
                  onSelectCard(base64Image);
                  onClose();
                }}
              />
            </CardContainer>
          );
        })}
      </CardsContainer>
      <Button
        fullWidth
        onClick={() => {
          dispatch(
            openModal({
              name: 'customizeCard',
              props: { cardSize, onSelectCard },
            }),
          );
        }}
        primary
      >
        Upload Custom Image
      </Button>
    </Modal>
  );
};

export default SelectCardModal;
